import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    },
    routes: [
        {
            path: '/',
            name: 'home',
            component: () =>
                import(/* webpackChunkName: "home" */ './views/Home'),
            meta: {
                preload: ['dom']
            }
                
        },
        {
            path: '/work/:slug',
            name: 'project',
            component: () =>
                import(/* webpackChunkName: "about" */ './views/Project')
        },
        {
            path: '*',
            redirect: { name: 'home' }
        }
    ]
})

// Router guard
router.beforeEach((to, from, next) => {
    // require preload? show preloader
    if (to.meta.preload && from.name !== to.name) {
        store.dispatch('startPreloading', to.meta.preload)
    }

    next()
})

export default router